<template>
  <div class="modal is-active">
    <div @click="$emit('close')" class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head flex-space-between">
        <p v-if="!editing" class="modal-card-title">
          {{ title }}
        </p>
        <input
          v-if="editing && isOwnerOrGroupAdmin"
          type="text"
          class="input"
          placeholder="Update title..."
          v-model="_title"
          />
        <a v-if="!inComment && !editing && isOwnerOrGroupAdmin" @click="editTag()">Edit</a>
        <a v-if="editing && isOwnerOrGroupAdmin" @click="updateTag()">Save</a>
        <button @click="$emit('close')" class="delete"></button>
      </header>
      <section class="modal-card-body">

         <div class="mb-2 d-flex">
          <strong class="mr-2">Color:</strong>
          <span class="tag mr-2" :style="{ 'background-color': '#' + color }"></span>
          <span v-if="!editing" > #{{color}}</span>
          <input v-else
            style="width: 100px;"
            type="text"
            class="input"
            placeholder="Update color..."
            v-model="_color"
          />

        </div>
        <div>
          <strong class="mr-2">Videos:</strong>
          <a target="_blank" :href="'/tags/' + id" class="mr-4">See list of videos with this tag</a>
        </div>

      </section>
      <footer class="modal-card-foot flex-space-between">
        <section v-if="!inComment">
          <div class="flex-align-center">
            <span class="mr-2 ml-2 text-bold bold">Tag Share Settings</span>
            <span class="select">
              <div class="select">
                <select @change="updateTagShare($event, id)">
                  <option :selected="isOwner && groupTag == true" value='true'>Group</option>
                  <option :selected="isOwner && groupTag == false" value='false'>Private</option>
                </select>
              </div>
            </span>
            <span class="tag" style="color: black;"
              data-balloon-length="large"
              :data-balloon="'Group Tag - This tag will show for every user\'s list in your group.   Private - This tag will only show on your list'"
              data-balloon-pos="top">?</span>
          </div>
        </section>
        <button v-if="!inComment && isOwnerOrGroupAdmin" @click="prepTag(id)" class="button is-small is-danger is-outlined pull-right">Archive</button>
      </footer>
    </div>

    <Confirm
      :show="showConfirm"
      :message="'This will archive the tag for future use, but tags already applied to videos will remain.'"
      :title="'Archive Tag'"
      :confirmFocus="true"
      :completeButtonText="'Archive'"
      @confirm="archiveTag()"
      @cancel="showConfirm = false"
    />


  </div>
</template>

<script>

import store from '../store.js'

import Tag from './Tag.vue'
import Dropdown from './Dropdown'
import Confirm from './Confirm.vue'

import {
  archiveTag,
  updateTagShare,
  updateTag,
} from '../actionTypes'

export default {
  name: 'TagOptionsModal',
  components: {
    Tag,
    Dropdown,
    Confirm,
  },
  data () {
    return {
      showConfirm: false,
      tagToArchive: null,
      editing: false,
      changeColor: false,
      _title: '',
      _color: '',
    }
  },
  computed: {
    userID () {
      return store.state.user.id
    },
    isOwner () {
      return this.owner === this.userID
    },
    isOwnerOrGroupAdmin () {
      return store.state.user.is_group_admin || this.isOwner
    },
    inComment () {
      return !(typeof this.commentID === 'undefined')
    },
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    color: {
      required: true,
    },
    groupTag: {
      type: Boolean,
      required: true,
    },
    rubric: {
      required: false,
    },
    title: {
      required: true,
    },
    owner: {
      required: true,
    },
    commentID: {
      required: false,
    },
  },
  methods: {
    async archiveTag () {
      await store.dispatch(archiveTag, this.tagToArchive)
      this.showConfirm = false
    },
    async updateTagShare (event, tagID) {
      const groupTag = event.target.value
      await store.dispatch(updateTagShare, { tagID, groupTag })
    },
    prepTag (tagID) {
      this.tagToArchive = tagID
      this.showConfirm = true
    },
    async updateTag () {
      const tagID = this.id
      const title = this._title
      const color = this._color
      await store.dispatch(updateTag, { tagID, title, color })
      this.editing = false
    },
    editTag () {
      this.editing = true
      this._color = this.color
      this._title = this.title
    },
  },
}

</script>

<style lang="scss" scoped>

.input {
  max-width: 75%;
}

.modal-card-title {
  line-height: inherit;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  max-width: 80%;
}

.modal-card-body {
  font-size: 1rem;
}

.tag {
  color: whitesmoke;
}  

.cf-tag {
  border-radius: 3px;
  min-height: 2rem;
  max-width: 400px;
  overflow-wrap: break-word;
  white-space: normal;
  padding-top: 2rem;
  padding-bottom: 2rem;
  font-weight: bold;
}

p {
  white-space: normal;
  word-break: break-word;
}

</style>



// WEBPACK FOOTER //
// TagOptionsModal.vue?4bfe3c00